// src/components/ServiceCard.tsx

import styles from './ServiceCard.module.css';
import Link from 'next/link';
import { ReactNode } from 'react';

interface ServiceCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  slug: string;
}

/**
 * Represents a single service preview card.
 * Wraps the whole card in a Link to `/services/[slug]`.
 * Title and icon respond to hover with amber accent.
 */
export default function ServiceCard({ title, description, icon, slug }: ServiceCardProps) {
  return (
    <Link href={`/services/${slug}`} className={styles.card}>
      {/* Icon box */}
      <div className={styles.iconWrapper}>
        {/* 🔥 This class MUST be applied for hover selector to work */}
        <div className={styles.icon}>{icon}</div>
      </div>

      {/* Service title */}
      <h3 className={styles.title}>{title}</h3>

      {/* Service description */}
      <p className={styles.description}>{description}</p>
    </Link>
  );
}
